<template>
  <component :is="component" :boardData="boardData" v-if="component"/>
</template>

<script>
export default {
  name: "BoardWriteLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    writeLayout: {},
    boardData: {default: () => {return {}}},
  },
  data() {
    return {
      component: null,
    }
  },
  created() {},
  mounted() {
    this.writeLoader()
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {
    loader() {
      if (!this.writeLayout) {
        return null
      }
      return () => import(`@/template/board/write/${this.writeLayout}`)
    },
  },
  methods: {
    writeLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/board/write/BoardWriteDefaultLayout')
          })
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>